export const defaultBarChartValue = () => {
  return {
    type: null,
    title: "",
    is_title_bold: false,
    x_title: "",
    is_x_title_bold: "",
    y_title: "",
    is_y_title_bold: "",
    step_size: 1,
    min_val: 0,
    max_val: 10,
    is_legend: true,
    is_gridlines: false,
    properties: [],
  };
};

export const defaultLineChartValue = () => {
  return {
    title: "",
    x_title: "",
    y_title: "",
    min_x_value: 0,
    max_x_value: 30,
    min_y_value: 0,
    max_y_value: 30,
    step_x_size: 1,
    step_y_size: 1,
    is_user_select_points: false,
    is_title_bold: false,
    is_show_lines: false,
    properties: [],
    selectable_answers: [],
    is_legend: false,
    is_curved: false,
    line_border_color: "red",
    point_radius: 4,
    is_allow_single_selection : false,
    is_custom_x_labels : false,
    styles : {
      width : 300,
      height : 300
    }
  };
};
